import { fileTypeFromBlob } from "file-type";
import { defaultOptions, ResolveDLPParams } from "@whatslly/commons/DLPExecutor";
import { WASMagic } from "@tuvisorg/wasmagic";

let magic: WASMagic;

const getMagicMimetype = async (content: File) => {
  const blobUrl = typeof localStorage !== "undefined" ? localStorage.getItem("tvsWasmBlobUrl") : undefined;
  if (!blobUrl) {
    return;
  }
  try {
    magic =
      magic ??
      (await WASMagic.create({
        moduleOptions: { locateFile: () => blobUrl },
      }));
    const arrayBuffer = await content.arrayBuffer();
    return magic.detect(new Uint8Array(arrayBuffer));
  } catch (err) {
    console.error("failed to get magic mimetype", err);
  }
};

export const getContentMimeType = async (params: ResolveDLPParams) => {
  const { content } = params;
  if (content instanceof File) {
    try {
      const magicMimeType = await getMagicMimetype(content);
      if (magicMimeType) {
        return magicMimeType;
      }
      const type = await fileTypeFromBlob(content);
      return type?.mime ?? params.mimeType ?? content.type;
    } catch {
      return params.mimeType ?? content.type;
    }
  }
  return params.mimeType;
};

export const nodeWebDefaultOptions = { ...defaultOptions, getContentMimeType };
